export default "__VITE_ASSET__OlfyWKQi__"